import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import "./cui/sass/cui.theme.scss";
import './App.scss';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Authenticated, OidcIdentity, getAccessToken } from '@rsmus/react-auth';
import CemAuthorization from 'cui/components/auth/cemAuthorization';
import { Eula } from '@rsmus/rsm-eula';
import PageLayout from 'cui/components/layouts/sharedLayout/PageLayout';

import { CattThemeProvider, Theme } from "./cui/components/CattThemeProvider";
import { envProperties } from './utils/EnvironmentProperties';
import IdleTimeLogout from 'cui/components/LogOut/IdleTimeLogout';

const App: React.FC = () => {
	const navigate = useNavigate()
	const location = useLocation()
	// function to handle the identity redirect call.
	const handleRedirect = (url: string) => {
		try {
			const fullUrl = new URL(url)
			if (fullUrl.pathname !== location.pathname) {
				navigate(fullUrl.pathname)
			} else {
				window.history.replaceState({}, '', url)
			}
		} catch (err) {
			console.log('handleRedirect error here ')
		}
	}
	const getToken = async (): Promise<string> => {
		const token = await getAccessToken();
		return token || '';
	}
	const identity = useMemo(() => {
		return (
			<OidcIdentity
				authority={envProperties.authentication.authority}
				client_id={envProperties.authentication.clientId}
				redirect_uri={window.location.origin}
				autoLogin
				redirectAfterLogout // works in conjunction with postLogoutRedirectUri
				postLogoutRedirectUri="https://rsmus.com"
				onDeepLinkRedirectCallback={handleRedirect}
				scope="openid profile tsa_investor_portal offline_access"
				accessTokenExpiringNotificationTimeInSeconds={120}
                automaticSilentRenew={true}
                silentRequestTimeoutInSeconds={60}
			>
				<Authenticated>
					<Eula host={envProperties.EulaApiUrl} tokenFactory={getToken}>
					<CemAuthorization>
						<IdleTimeLogout />
						<CattThemeProvider theme={Theme.BLUE}>
							<PageLayout />
						</CattThemeProvider>
					</CemAuthorization>
					</Eula>
				</Authenticated>
			</OidcIdentity>
		)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	return identity
}
export default App
